import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Injectable()
export class AdminGuard implements CanActivate {
  admins = [
    'enoch@abassey.com',
    'maseko@bongane.com',
    'charles@asante.com',
    'kabelo.ndlovu1@gmail.com',
    'maseko.iaggauteng@vodamail.co.za',
    'casante@charlitex.com',

    // Hospitality team
    'mathole.pa@gracebiblechurch.org.za',
    'thuli.mageba@gmail.com',
    'admin@e21africa.co.za'
  ];
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.user.pipe(
      map(auth => {
        return this.admins.includes(auth.email);
      })
    );
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/services/admin.guard.ts